

import React, { useState, useEffect } from "react";
import "./EmployeeAsign.css";
import { MdModeEdit } from "react-icons/md";
import { TiEye } from "react-icons/ti";
import { FiSave, FiX } from "react-icons/fi";
import * as employeeService from "../../../Servicefile/employeeService";
import { useLoader } from "../../../../context/LoaderProvider";

// ==================== 🔥 EASY CONFIGURATION - EDIT THIS SECTION ====================
// Modules Configuration
const MODULES_CONFIG = [
    {
        backendName: "Dashboard", displayName: "Dashboard", order: 1, showInUI: true, subModules: [
            //  { backendName: "DASHBOARD", displayName: "Dashboard" }
        ]
    },
    {
        backendName: "subscription",
        displayName: "Subscription",
        order: 2,
        showInUI: true,
        subModules: [
            { backendName: "ABOUT_US", displayName: "Subscription Access" }
        ]
    },
    {
        backendName: "Client_Management",
        displayName: "Client Management",
        order: 3,
        showInUI: true,
        subModules: [
            { backendName: "FOOD_AND_BEVERAGES", displayName: "Food and Beverages" },
            { backendName: "LOGISTICS_SUPPLY", displayName: "Logistics" },
            // { backendName: "BILLING_SETTINGS", displayName: "Billing Settings" }
        ]
    },
    {
        backendName: "Order_Management",
        displayName: "Order Management",
        order: 4,
        showInUI: true,
        subModules: [
            { backendName: "FOOD_AND_BEVERAGES", displayName: "Food and Beverage" },
            { backendName: "CATERINGS_SERVICES", displayName: "Caterings" },
            { backendName: "LOGISTICS_SUPPLY", displayName: "Logistics" }
        ]
    },
    {
        backendName: "Menu_Management",
        displayName: "Menu Management",
        order: 5,
        showInUI: true,
        subModules: [
            { backendName: "FOOD_AND_BEVERAGES", displayName: "Food and Beverages" },
            { backendName: "CATERINGS_SERVICES", displayName: "Catering" }
        ]
    },
    {
        backendName: "user_management",
        displayName: "User Management",
        order: 7,
        showInUI: true,
        subModules: [
            { backendName: "DIRECTORY", displayName: "user" },
        ]
    },
    {
        backendName: "Settings_Controls",
        displayName: "Settings & Control",
        order: 8,
        showInUI: true,
        subModules: [
            { backendName: "FOOD_AND_BEVERAGES", displayName: "Food and Beverages" },
            { backendName: "CATERINGS_SERVICES", displayName: "Catering" }
        ]
    },
    {
        backendName: "Team_Management",
        displayName: "Team Management",
        order: 9,
        showInUI: true,
        subModules: [
            { backendName: "RAISE_TICKET", displayName: "Directory" },
            { backendName: "FAQ", displayName: "Roles and Controls" }
        ]
    },
    {
        backendName: "Promotions_Discounts",
        displayName: "Promotions and Discount",
        order: 18,
        showInUI: true,
        subModules: [
            { backendName: "CREATE_CAMPAIGN", displayName: "Create Campaign" },
            // { backendName: "REPORTS_REVENUE", displayName: "Revenue" },
            { backendName: "CAMPAIGN", displayName: "Campaigns" },
            { backendName: "PROMOTIONS_ANALYSTICS", displayName: "Analytics" },
            { backendName: "DIGITAL_SCREEN", displayName: "Digital Screens" },

        ]
    },
    {
        backendName: "Support_system",
        displayName: "Support System",
        order: 19,
        showInUI: true,
        subModules: [
            { backendName: "REPORTS_OVERVIEW", displayName: "Platform Tickets" },
            // { backendName: "REPORTS_REVENUE", displayName: "Revenue" },
            { backendName: "REPORT_PAYMENTS", displayName: "Internal Tickets" }

        ]
    },
    {
        backendName: "Report_Analysis",
        displayName: "Report and Analysis",
        order: 19,
        showInUI: true,
        subModules: [
            { backendName: "FOOD_AND_BEVERAGES", displayName: "Food and Beverages" },
            // { backendName: "REPORTS_REVENUE", displayName: "Revenue" },
            { backendName: "CATERINGS_SERVICES", displayName: "Catering" }

        ]
    },
];

// ==================== END OF CONFIGURATION ====================

const generateModuleConfig = () => {
    const config = {};
    MODULES_CONFIG.forEach(module => {
        config[module.backendName] = {
            displayName: module.displayName,
            order: module.order,
            hasSubModules: module.subModules.length > 0
        };
    });
    return config;
};

const generateSubModulesConfig = () => {
    const config = {};
    MODULES_CONFIG.forEach(module => {
        if (module.subModules.length > 0) {
            config[module.backendName] = module.subModules.map((sub) => ({
                id: sub.backendName,
                name: sub.displayName,
                backendName: sub.backendName,
                displayName: sub.displayName
            }));
        }
    });
    return config;
};

const MODULE_CONFIG = generateModuleConfig();
const SUBMODULES_CONFIG = generateSubModulesConfig();

const getSubModuleDisplayName = (backendName) => {
    for (const module of MODULES_CONFIG) {
        const sub = module.subModules.find(s => s.backendName === backendName);
        if (sub) return sub.displayName;
    }
    return backendName.replace(/_/g, ' ');
};

const getSubModulesForModule = (moduleName) => {
    return SUBMODULES_CONFIG[moduleName] || [];
};

const normalizeModuleName = (localStorageName) => {
    const mapping = {
        // Direct matches
        "HOME": "Home",
        "COMPANY": "Company",
        "SETTINGS_CONTROLS": "Settings_Controls",
        "PROMOTIONS": "Promotions_Discounts",
        "MENU_MANAGEMENT": "Menu_Management",
        "REPORTS": "Report_Analysis",
        "CARE": "Care_Management",
        "SUBSCRIPTION": "subscription",
        "USER_MANAGEMENT": "user_management",
        "CLIENT_MANAGEMENT": "Client_Management",
        "SUPPORT": "Support_system",
        "DASHBOARD": "Dashboard",


    };

    return mapping[localStorageName] || localStorageName;
};
const EmployeeAsign = () => {
    const [modules, setModules] = useState([]);
    const [allEmployees, setAllEmployees] = useState([]);
    const [assignedEmployees, setAssignedEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [showViewModal, setShowViewModal] = useState(false);
    const [viewEmployee, setViewEmployee] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editingEmployee, setEditingEmployee] = useState(null);
    const [selectedItems, setSelectedItems] = useState({
        modules: [],
        subModules: []
    });
    const [selectAll, setSelectAll] = useState(false);
    const [employeeSearch, setEmployeeSearch] = useState("");
    const [snackbar, setSnackbar] = useState({ show: false, message: '', type: 'success' });
    const [isSearchActive, setIsSearchActive] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);

    const { showLoader, hideLoader } = useLoader();

    const showNotification = (message, type = 'success') => {
        setSnackbar({ show: true, message, type });
        setTimeout(() => setSnackbar({ show: false, message: '', type: 'success' }), 3000);
    };

    const showCheckboxes = selectedEmployee !== null;

    // Load modules from config
    useEffect(() => {
        const loadModulesFromStorage = () => {
            try {
                const allModules = MODULES_CONFIG
                    .filter(config => config.showInUI === true)
                    .map(config => config.backendName);

                const sortedModules = allModules.sort((a, b) => {
                    const configA = MODULE_CONFIG[a] || { order: 999 };
                    const configB = MODULE_CONFIG[b] || { order: 999 };
                    return (configA.order || 999) - (configB.order || 999);
                });

                const formattedModules = sortedModules.map((backendName, index) => {
                    const config = MODULE_CONFIG[backendName] || {
                        displayName: backendName.replace(/_/g, ' '),
                        order: 999,
                        hasSubModules: false
                    };

                    return {
                        id: index + 1,
                        originalName: backendName,
                        name: config.displayName,
                        hasSubModules: config.hasSubModules,
                        subModules: getSubModulesForModule(backendName)
                    };
                });

                setModules(formattedModules);
            } catch (error) {
                console.error("Error loading modules:", error);
                setModules([]);
            }
        };

        loadModulesFromStorage();
    }, []);

    // Fetch all employees
    useEffect(() => {
        fetchAllEmployees();
    }, []);

    const fetchAllEmployees = async () => {
        try {
            showLoader();

            const data = await employeeService.fetchEmployees();

            console.log("📦 Raw API Employees:", data);

            const formattedEmployees = data.map(emp => ({
                id: emp.id,
                name: emp.name,
                role: emp.handlingRole || "N/A",

                assignedDate: emp.registerTime || new Date(),

                status: emp.enabled ? "active" : "inactive",

                modules: emp.businessModules || [],
                subModules: emp.adminSubModules || [],

                original: emp
            }));

            setAllEmployees(formattedEmployees);

            // ✅ FILTER (ONLY REAL ASSIGNED)
            const assigned = formattedEmployees.filter(emp => {
                const hasValidModules =
                    emp.modules?.some(m => m && m !== "Home");

                const hasSubModules =
                    emp.subModules?.length > 0;

                return hasValidModules || hasSubModules;
            });

            console.log("✅ Assigned Employees:", assigned);

            setAssignedEmployees(assigned);

        } catch (error) {
            console.error("❌ Failed to fetch employees:", error);
            showNotification("Failed to fetch employees", "error");
        } finally {
            hideLoader();
        }
    };

    const getModuleOriginalNamesFromIds = (moduleIds) => {
        return moduleIds.map(id => {
            const module = modules.find(m => m.id === id);
            return module?.originalName;
        }).filter(name => name !== undefined);
    };

    const getSubModuleBackendNamesFromIds = (subModulesObj) => {
        const backendNames = [];

        if (!subModulesObj || typeof subModulesObj !== "object") {
            return backendNames;
        }

        Object.entries(subModulesObj).forEach(([moduleId, subIds]) => {
            const module = modules.find(m => m.id === Number(moduleId));

            if (!module || !Array.isArray(subIds)) return;

            module.subModules.forEach(sub => {
                if (subIds.includes(sub.id)) {
                    backendNames.push(sub.backendName);
                }
            });
        });

        return backendNames;
    };

    const handleSelectAll = () => {
        if (!showCheckboxes) {
            showNotification("Please select an employee first", "warning");
            return;
        }

        if (selectAll) {
            setSelectedItems({ modules: [], subModules: {} });
            setSelectAll(false);
        } else {
            const allModuleIds = modules.map(m => m.id);

            const allSubModules = {};
            modules.forEach(module => {
                allSubModules[module.id] = module.subModules.map(sm => sm.id);
            });

            setSelectedItems({
                modules: allModuleIds,
                subModules: allSubModules
            });

            setSelectAll(true);
        }
    };

    const handleModuleChange = (moduleId) => {
        const module = modules.find(m => m.id === moduleId);
        const subModuleIds = module.subModules.map(sm => sm.id);

        setSelectedItems(prev => {
            const isSelected = prev.modules.includes(moduleId);

            let newModules = [...prev.modules];
            let newSubModules = { ...prev.subModules };

            if (isSelected) {
                // ❌ remove module
                newModules = newModules.filter(id => id !== moduleId);
                delete newSubModules[moduleId];
            } else {
                // ✅ add module
                newModules.push(moduleId);
                newSubModules[moduleId] = subModuleIds;
            }

            return {
                modules: newModules,
                subModules: newSubModules
            };
        });
    };

    const handleSubModuleChange = (moduleId, subModuleId) => {
        setSelectedItems(prev => {
            const moduleSubs = prev.subModules[moduleId] || [];

            let updatedSubs;

            if (moduleSubs.includes(subModuleId)) {
                updatedSubs = moduleSubs.filter(id => id !== subModuleId);
            } else {
                updatedSubs = [...moduleSubs, subModuleId];
            }

            const newSubModules = {
                ...prev.subModules,
                [moduleId]: updatedSubs
            };

            // ✅ handle module selection
            let newModules = [...prev.modules];

            if (updatedSubs.length > 0 && !newModules.includes(moduleId)) {
                newModules.push(moduleId);
            }

            if (updatedSubs.length === 0) {
                newModules = newModules.filter(id => id !== moduleId);
            }

            return {
                modules: newModules,
                subModules: newSubModules
            };
        });
    };

    const handleEmployeeSelect = (employee) => {
        setSelectedEmployee(employee);
        setIsSearchActive(false);
        setEmployeeSearch("");
        showNotification(`Employee ${employee.name} selected`, "success");
        setSelectedItems({ modules: [], subModules: [] });
        setSelectAll(false);
    };
    const normalizeAdminSubModule = (name) => {
        const mapping = {
            "ABOUT_US": "ENQUIRY",
            "RAISE_TICKET": "ENQUIRY",
            "FAQ": "ROLES_AND_CONTROLS",
            "REPORTS_OVERVIEW": "CREATE_CAMPAIGN",
            "REPORT_PAYMENTS": "CAMPAIGN",
            "REPORTS_ORDERS": "PROMOTIONS_ANALYSTICS",
            "REVIEWS_RATINGS": "DIGITAL_SCREEN",
            "FOOD_AND_BEVERAGES": "DIRECTORY",
            "LOGISTICS_SUPPLY": "ORDERS",
            "CATERINGS_SERVICES": "ORDERS"
        };

        return mapping[name] || name;
    };
    const handleSave = async () => {
        if (!selectedEmployee) {
            showNotification("Please select an employee first", "warning");
            return;
        }

        if (selectedItems.modules.length === 0) {
            showNotification("Please select at least one module", "warning");
            return;
        }

        try {
            showLoader();

            const employeeData = selectedEmployee;

            if (!employeeData?.id) {
                showNotification("Invalid employee selected", "error");
                return;
            }

            // ✅ VALID MODULES
            const VALID_MODULES = [
                "Home", "Company", "Settings_Controls", "Account_History",
                "Order_Management", "Inventory_Management", "Chef_Management",
                "Delivery_Management", "Promotions_Discounts", "Menu_Management",
                "Table_Management", "Report_Analysis", "Pay_outs",
                "Care_Management", "subscription", "user_management",
                "Payment_Transactions", "Client_Management", "Support_system", "Dashboard"
            ];

            // ✅ clean existing modules
            const existingModules = (employeeData.businessModules || [])
                .filter(m => VALID_MODULES.includes(m));

            const newSelectedModules = getModuleOriginalNamesFromIds(selectedItems.modules);

            // ✅ remove duplicates
            const allModules = [
                ...new Set([...existingModules, ...newSelectedModules])
            ];

            // ✅ FIX: use adminSubModules (NOT subModules) 
            const adminSubModules = [
                ...new Set(
                    getSubModuleBackendNamesFromIds(selectedItems.subModules)
                        .map(normalizeAdminSubModule)
                )
            ];

            const payload = {
                businessVerticals: ["FOOD_AND_BEVERAGES"], // ✅ required
                businessModules: allModules,
                adminSubModules: adminSubModules
            };

            console.log("FINAL PAYLOAD:", payload);

            await employeeService.updateEmployeeModules(employeeData.id, payload);

            showNotification("Modules assigned successfully!", "success");
            await fetchAllEmployees();

            setSelectedEmployee(null);
            setSelectedItems({ modules: [], subModules: [] });
            setSelectAll(false);

        } catch (error) {
            console.error("Failed to assign modules:", error);
            showNotification(error.response?.data?.message || "Failed to assign permissions", "error");
        } finally {
            hideLoader();
        }
    };

    const handleStatusToggle = async (assignmentId) => {
        const employee = assignedEmployees.find(e => e.id === assignmentId);
        if (!employee) return;

        const currentStatus = employee.status;
        const newStatus = currentStatus === "active" ? "inactive" : "active";
        const newStatusText = newStatus === "active" ? "Active" : "Inactive";

        setAssignedEmployees(prev =>
            prev.map(emp =>
                emp.id === assignmentId ? { ...emp, status: newStatus } : emp
            )
        );

        try {
            showLoader();
            await employeeService.updateEmployeeStatus(employee.employeeId, newStatusText);
            showNotification(`Employee ${employee.name} status updated to ${newStatusText}`, "success");
            await fetchAllEmployees();
        } catch (error) {
            setAssignedEmployees(prev =>
                prev.map(emp =>
                    emp.id === assignmentId ? { ...emp, status: currentStatus } : emp
                )
            );
            showNotification(error.response?.data?.message || "Failed to update status", "error");
        } finally {
            hideLoader();
        }
    };

    const handleViewModules = (employee) => {
        setViewEmployee(employee);
        setShowViewModal(true);
    };

    const handleEdit = async (employee) => {
        try {
            showLoader();

            console.log("🟡 Clicked Employee:", employee);

            const allEmps = await employeeService.fetchEmployees();

            console.log("📦 All Employees from API:", allEmps);

            // ✅ FIX: use id directly
            const employeeData = allEmps.find(
                emp => String(emp.id) === String(employee.id)
            );

            console.log("🔍 Edit Employee Data:", employeeData);

            if (!employeeData) {
                showNotification("Employee data not found", "error");
                return;
            }

            // ✅ map modules
            const moduleIds = employeeData.businessModules?.map(moduleName => {
                const module = modules.find(m => m.originalName === moduleName);
                return module?.id;
            }).filter(Boolean) || [];

            // ✅ map submodules (adminSubModules)
            const subModuleIds = employeeData.adminSubModules?.map(subName => {
                for (const module of modules) {
                    const sub = module.subModules.find(sm => sm.backendName === subName);
                    if (sub) return sub.id;
                }
                return null;
            }).filter(Boolean) || [];

            setEditingEmployee({
                ...employee,
                original: employeeData
            });

            setSelectedItems({
                modules: moduleIds,
                subModules: subModuleIds
            });

            setSelectAll(moduleIds.length === modules.length);
            setShowEditModal(true);

        } catch (error) {
            console.error("❌ Edit error:", error);
            showNotification("Failed to load employee data", "error");
        } finally {
            hideLoader();
        }
    };



    const handleSaveEdit = async () => {
        if (!editingEmployee) return;

        try {
            showLoader();

            console.log("🟡 Editing Employee:", editingEmployee);

            // ✅ modules
            const newSelectedModules =
                getModuleOriginalNamesFromIds(selectedItems.modules) || [];

            // ✅ submodules (normalized + unique)
            const adminSubModules = [
                ...new Set(
                    (getSubModuleBackendNamesFromIds(selectedItems.subModules) || [])
                        .map(normalizeAdminSubModule)
                )
            ];

            // ✅ prevent empty payload
            if (newSelectedModules.length === 0 && adminSubModules.length === 0) {
                showNotification("Please select at least one module or submodule", "warning");
                return;
            }

            const payload = {
                businessVerticals: ["FOOD_AND_BEVERAGES"],
                businessModules: newSelectedModules,
                adminSubModules: adminSubModules
            };

            console.log("✏️ EDIT PAYLOAD:", payload);

            // ✅ FIX: use id (NOT employeeId)
            const empId = editingEmployee.id || editingEmployee.employeeId;

            if (!empId) {
                throw new Error("Invalid employee id");
            }

            await employeeService.updateEmployeeModules(empId, payload);

            showNotification("Modules updated successfully!", "success");

            // ✅ close modal + reset
            setShowEditModal(false);
            setEditingEmployee(null);
            setSelectedItems({ modules: [], subModules: [] });
            setSelectAll(false);

            // ✅ refresh latest data
            await fetchAllEmployees();

        } catch (error) {
            console.error("❌ Failed to update modules:", error);
            showNotification(
                error.response?.data?.message || error.message || "Failed to save changes",
                "error"
            );
        } finally {
            hideLoader();
        }
    };

    const handleCancelEdit = () => {
        setShowEditModal(false);
        setEditingEmployee(null);
        setSelectedItems({ modules: [], subModules: [] });
        setSelectAll(false);
    };

    const filteredEmployees = employeeSearch.trim() !== ""
        ? allEmployees.filter(emp =>
            emp.name?.toLowerCase().includes(employeeSearch.toLowerCase()) ||
            emp.role?.toLowerCase().includes(employeeSearch.toLowerCase())
        )
        : [];

    return (
        <div className="assignmodule-container" >
            {snackbar.show && (
                <div className={`assignmodule-toast assignmodule-toast-${snackbar.type}`}>
                    {snackbar.message}
                </div>
            )}

            {/* Header with all controls in one line */}
            <div className="assignmodule-header">
                {!selectedEmployee ? (
                    // No employee selected - show assign button or search
                    !isSearchActive ? (
                        <button className="assignmodule-assign-btn" onClick={() => setIsSearchActive(true)}>
                            + Assign Employee
                        </button>
                    ) : (
                        <>
                            <div className="assignmodule-search-wrapper">
                                <input
                                    type="text"
                                    className="assignmodule-search-input"
                                    placeholder="🔍 Search employee by name or role..."
                                    value={employeeSearch}
                                    onChange={(e) => setEmployeeSearch(e.target.value)}
                                    onFocus={() => setShowDropdown(true)}
                                    autoFocus
                                />
                            </div>
                            <button
                                className="assignmodule-search-cancel"
                                onClick={() => {
                                    setIsSearchActive(false);
                                    setEmployeeSearch("");
                                }}
                            >
                                Cancel
                            </button>
                        </>
                    )
                ) : (
                    // Employee selected - show employee info and save button
                    <>
                        <div className="assignmodule-selected-info">
                            <span className="selected-label">Assigning to:</span>
                            <span className="selected-name">{selectedEmployee.name}</span>
                            <span className="selected-role">({selectedEmployee.role})</span>
                            <button
                                className="selected-change-btn"
                                onClick={() => {
                                    setSelectedEmployee(null);
                                    setIsSearchActive(true);
                                    setEmployeeSearch("");
                                    setSelectedItems({ modules: [], subModules: [] });
                                    setSelectAll(false);
                                }}
                            >
                                Change
                            </button>
                        </div>
                        <button className="assignmodule-save-btn" onClick={handleSave}>
                            Save
                        </button>
                    </>
                )}
            </div>

            {/* Search Suggestions Dropdown */}
            {isSearchActive && !selectedEmployee && employeeSearch.trim() !== "" && (
                <div className="assignmodule-suggestions-dropdown">
                    {filteredEmployees.length === 0 ? (
                        <div className="assignmodule-suggestions-empty">
                            <span>😕</span>
                            <span>No employees found for "{employeeSearch}"</span>
                        </div>
                    ) : (
                        filteredEmployees.map((emp) => (
                            <div
                                key={emp.id}
                                className="assignmodule-suggestion-item"
                                onClick={() => {
                                    setSelectedEmployee(emp);
                                    setIsSearchActive(false);
                                    setEmployeeSearch("");
                                    setSelectedItems({ modules: [], subModules: [] });
                                    setSelectAll(false);
                                    showNotification(`Employee ${emp.name} selected`, "success");
                                }}
                            >
                                <div className="assignmodule-suggestion-avatar">
                                    {emp.name?.charAt(0).toUpperCase()}
                                </div>
                                <div className="assignmodule-suggestion-info">
                                    <div className="assignmodule-suggestion-name">{emp.name}</div>
                                    <div className="assignmodule-suggestion-role">{emp.role}</div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            )}

            {/* No Modules Message */}
            {modules.length === 0 && (
                <div className="assignmodule-info-banner">
                    <span className="info-icon">ℹ️</span>
                    <span>No modules available. Please check your subscription.</span>
                </div>
            )}

            {/* Modules Table */}
            {modules.length > 0 && (
                <div className="assignmodule-table-container">
                    <table className="assignmodule-table">
                        <thead>
                            <tr>
                                <th style={{ width: '30%' }}>
                                    {selectedEmployee ? (
                                        <div
                                            className={`module-header-selectall ${selectAll ? 'active' : ''}`}
                                            onClick={handleSelectAll}
                                            style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '8px' }}
                                        >
                                            <span className="btn-icon">{selectAll ? '✓' : '☐'}</span>
                                            <span>Modules</span>
                                        </div>
                                    ) : (
                                        <span>Modules</span>
                                    )}
                                </th>
                                <th style={{ width: '70%' }}>Sub Modules</th>
                            </tr>
                        </thead>
                        <tbody>
                            {modules.map((module) => (
                                <tr key={module.id}>
                                    <td className="module-cell">
                                        {selectedEmployee ? (
                                            <label className="checkbox-label">
                                                <input
                                                    type="checkbox"
                                                    checked={selectedItems.modules.includes(module.id)}
                                                    onChange={() => handleModuleChange(module.id)}
                                                />
                                                <span className="module-name">{module.name}</span>
                                            </label>
                                        ) : (
                                            <span className="module-name">{module.name}</span>
                                        )}
                                    </td>
                                    <td className="submodule-cell">
                                        {module.hasSubModules && module.subModules.length > 0 ? (
                                            <div className="submodules-grid">
                                                {module.subModules.map((subModule) => (
                                                    <div key={subModule.id} className="submodule-item">
                                                        {selectedEmployee ? (
                                                            <label className="checkbox-label">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedItems.subModules[module.id]?.includes(subModule.id) || false}
                                                                    onChange={() => handleSubModuleChange(module.id, subModule.id)}
                                                                />
                                                                <span className="submodule-name">{subModule.name}</span>
                                                            </label>
                                                        ) : (
                                                            <span className="submodule-name">{subModule.name}</span>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <span style={{ color: '#999', fontSize: '13px', fontStyle: 'italic' }}>
                                                No sub-modules available
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Assigned Employees Table */}
            <div className="assignmodule-assigned-section">
                <h3 className="assignmodule-section-title">Assigned Employees</h3>
                <div className="assignmodule-assigned-container">
                    <table className="assignmodule-assigned-table">
                        <thead>
                            <tr>
                                <th>Employee Name</th>
                                <th>Role</th>
                                <th>Assigned Date</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {assignedEmployees.length === 0 ? (
                                <tr>
                                    <td colSpan="5" className="empty-state">No employees assigned yet</td>
                                </tr>
                            ) : (
                                assignedEmployees.map((emp) => (
                                    <tr key={emp.id}>
                                        <td>{emp.name}</td>
                                        <td>{emp.role}</td>
                                        <td>{new Date(emp.assignedDate).toLocaleDateString('en-IN', {
                                            day: '2-digit',
                                            month: 'short',
                                            year: 'numeric'
                                        })}</td>
                                        <td>
                                            <div className="status-toggle">
                                                <label className="assignmodule-switch">
                                                    <input
                                                        type="checkbox"
                                                        checked={emp.status === "active"}
                                                        onChange={() => handleStatusToggle(emp.id)}
                                                    />
                                                    <span className="assignmodule-slider"></span>
                                                </label>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="action-buttons">
                                                <button
                                                    className="action-btn view-btn"
                                                    onClick={() => handleViewModules(emp)}
                                                    title="View Modules"
                                                >
                                                    <TiEye />
                                                </button>
                                                <button
                                                    className="action-btn edit-btn"
                                                    onClick={() => handleEdit(emp)}
                                                    title="Edit Modules"
                                                >
                                                    <MdModeEdit />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* View Modules Modal */}
            {showViewModal && viewEmployee && (
                <div className="assignmodule-modal-overlay" onClick={() => setShowViewModal(false)}>
                    <div className="assignmodule-modal assignmodule-view-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="assignmodule-modal-header">
                            <h3>Assigned Modules - {viewEmployee.name}</h3>
                            <button className="modal-close-btn" onClick={() => setShowViewModal(false)}><FiX /></button>
                        </div>
                        <div className="assignmodule-modal-body">
                            <div className="view-modules-list">
                                {modules.map((module) => {
                                    const isModuleAssigned = viewEmployee.modules?.includes(module.originalName);
                                    const assignedSubModules = module.subModules.filter(sm =>
                                        viewEmployee.subModules?.includes(sm.backendName)
                                    );

                                    if (!isModuleAssigned && assignedSubModules.length === 0) return null;

                                    return (
                                        <div key={module.id} className="view-module-item">
                                            <div className="view-module-name">
                                                <span className={`view-module-icon ${isModuleAssigned ? 'assigned' : 'partial'}`}>
                                                    {isModuleAssigned ? '✓' : '◐'}
                                                </span>
                                                {module.name}
                                            </div>
                                            {assignedSubModules.length > 0 && (
                                                <div className="view-submodules">
                                                    {assignedSubModules.map(sm => (
                                                        <span key={sm.id} className="view-submodule-tag">{sm.name}</span>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                                {modules.every(module => {
                                    const isModuleAssigned = viewEmployee.modules?.includes(module.originalName);
                                    const assignedSubModules = module.subModules.filter(sm =>
                                        viewEmployee.subModules?.includes(sm.backendName)
                                    );
                                    return !isModuleAssigned && assignedSubModules.length === 0;
                                }) && (
                                        <div className="view-empty-state">
                                            <span>📭</span>
                                            <p>No modules assigned to this employee</p>
                                        </div>
                                    )}
                            </div>
                        </div>
                        <div className="assignmodule-modal-footer">
                            <button className="modal-cancel-btn" onClick={() => setShowViewModal(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Modules Modal */}
            {showEditModal && editingEmployee && (
                <div className="assignmodule-modal-overlay" onClick={() => setShowEditModal(false)}>
                    <div className="assignmodule-modal assignmodule-edit-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="assignmodule-modal-header">
                            <div className="edit-modal-selectall">
                                <button
                                    className={`edit-selectall-btn ${selectAll ? 'active' : ''}`}
                                    onClick={() => {
                                        if (selectAll) {
                                            setSelectedItems({ modules: [], subModules: [] });
                                            setSelectAll(false);
                                        } else {
                                            const allModuleIds = modules.map(m => m.id);
                                            const allSubModuleIds = modules.flatMap(m => m.subModules.map(sm => sm.id));
                                            setSelectedItems({ modules: allModuleIds, subModules: allSubModuleIds });
                                            setSelectAll(true);
                                        }
                                    }}
                                >
                                    <span className="btn-icon">{selectAll ? '✓' : '☐'}</span>
                                    {selectAll ? 'Deselect All' : 'Select All'}
                                </button>
                            </div>
                            <h3>Edit Permissions - {editingEmployee.name}</h3>
                            <button className="modal-close-btn" onClick={() => setShowEditModal(false)}><FiX /></button>
                        </div>
                        <div className="assignmodule-modal-body">
                            <div className="edit-modal-content">
                                <div className="edit-modules-table">
                                    <table className="edit-modules-table-inner">
                                        <thead>
                                            <tr>
                                                <th style={{ width: '30%' }}>Modules</th>
                                                <th style={{ width: '70%' }}>Sub Modules</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {modules.map((module) => (
                                                <tr key={module.id}>
                                                    <td className="module-cell">
                                                        <label className="checkbox-label">
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedItems.modules.includes(module.id)}
                                                                onChange={() => handleModuleChange(module.id)}
                                                            />
                                                            <span className="module-name">{module.name}</span>
                                                        </label>
                                                    </td>
                                                    <td className="submodule-cell">
                                                        {module.originalName === "DASHBOARD" ? (
                                                            <span style={{ color: '#666', fontSize: '13px' }}>Dashboard Access</span>
                                                        ) : module.originalName === "SUBSCRIPTION_MANAGEMENT" ? (
                                                            <span style={{ color: '#666', fontSize: '13px' }}>Subscription Access</span>
                                                        ) : module.originalName === "PRODUCTS_PRICES" ? (
                                                            <span style={{ color: '#666', fontSize: '13px' }}>Product Management Access</span>
                                                        ) : module.hasSubModules && module.subModules.length > 0 ? (
                                                            <div className="submodules-grid">
                                                                {module.subModules.map((subModule) => (
                                                                    <div key={subModule.id} className="submodule-item">
                                                                        {editingEmployee ? (  // ✅ CORRECT - use editingEmployee
                                                                            <label className="checkbox-label">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={selectedItems.subModules[module.id]?.includes(subModule.id) || false}
                                                                                    onChange={() => handleSubModuleChange(module.id, subModule.id)}
                                                                                />
                                                                                <span className="submodule-name">{subModule.name}</span>
                                                                            </label>
                                                                        ) : (
                                                                            <span className="submodule-name">{subModule.name}</span>
                                                                        )}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ) : (
                                                            <span style={{ color: '#999', fontSize: '13px', fontStyle: 'italic' }}>No sub-modules available</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="assignmodule-modal-footer">
                            <button className="modal-cancel-btn" onClick={handleCancelEdit}>Cancel</button>
                            <button className="modal-save-btn" onClick={handleSaveEdit}><FiSave /> Save Changes</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EmployeeAsign;